module.exports = __webpack_public_path__ + "daa8dabea771aed81d0b5fc83070b846.pdf";